const questions = [
	{
		id: 0,
		question: '¿Quién puede tomar este máster?',
		answer: [
			'Cualquier persona mayor de 18 años desde cualquier parte del  mundo que cuente con los requisitos mínimos en su equipo de computo y tenga conocimientos básicos consolidados en ZBrush.',
		],
	},
	{
		id: 1,
		question: '¿Cómo son las clases online?',
		answer: [
			'Serán clases en vídeo a través de nuestra plataforma y feedback  en vivo por Zoom durante 3 meses. También estarás unido(a) a un grupo privado en Discord. Revisa nuestro módulo "Método de estudio" para ampliar la información.',
		],
	},
	{
		id: 2,
		question: '¿Por qué elegir a Libel Academy?',
		answer: [
			'Tenemos un método de estudio controlado para aprender desde cero y en corto tiempo, donde el estudiante recibe todo el contenido en los tiempos estipulados, adicionalmente, entregamos material de diferentes niveles para que su proceso de aprendizaje no se detenga.',
			'Nuestros docentes son especialistas en cada una de sus áreas (no son generalistas).',
			'Los resultados de nuestros estudiantes son realmente sorprendentes.',
			'Puedes revisar todos nuestros beneficios en nuestra home.',
		],
	},
	{
		id: 3,
		question: '¿Qué sucede si no puedo asistir a un feedback en vivo?',
		answer: [
			'Todas nuestras sesiones en vivo quedan grabadas y se cargan en nuestra plataforma 24 horas hábiles después para que puedas repetirlas por si no pudiste asistir o necesitas repasar.',
		],
	},
	{
		id: 4,
		question: '¿Qué conocimientos tendré al finalizar?',
		answer: [
			'Tendrás todo el conocimiento para crear un modelado de escultura de criaturas fantásticas',
		],
	},
];

export default questions;
